module.exports = __webpack_public_path__ + "static/media/tienda-naranja-viajes-logo-blanco.6bfdf9ce.svg";